import { useEffect, useState } from 'react';

const DURATION_MS = (17 * 60 + 34) * 1000;
// Shared start so every timer on the page stays in sync.
const START = Date.now();

function remaining(): number {
  const elapsed = (Date.now() - START) % DURATION_MS;
  return DURATION_MS - elapsed;
}

export function useCountdown() {
  const [ms, setMs] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setMs(remaining()), 250);
    return () => window.clearInterval(id);
  }, []);

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
